export enum Sex {
  Male = 'male',
  Female = 'female',
}
